/**
 * State where a list of addresses is displayed.
 * @param addresses addresses to display.
 * @param onAddress callback of type Address => Unit to invoke when an address is selected.
 * @param onNewAddress callback to invoke when user selects a "no address" action.
 */
define([], () => ({addresses, onAddress, onNewAddress}) => {
    return {
        get addresses() {
            return addresses;
        },
        select: onAddress,
        createNew: onNewAddress
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/address/models/AddressListState.js
 **/